
import Vue from 'vue'
import store from './store'

// 引入全局css
import './assets/style/style.scss';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.config.productionTip = false
import 'echarts'
import 'echarts-gl'
// 图片放大全局yarn
import './assets/style/style.scss';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

// 路由守卫
import './permission' // permission control

// 地图
import './assets/css/reset.css'

if (process.env.NODE_ENV !== 'development') {  // process是Node环境全部变量, 运行时根据敲击的命令不同, 脚手架会取环境变量给env添加属性和值
  console.log = function () { }
  console.error = function () { }
  console.dir = function () { }
}





const dashboardFlexible = require('lib-flexible-for-dashboard');
dashboardFlexible.init(37/15)



import App from './App'
import router from './router'
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js